/**
 * Creates a URL using {@link https://www.contentful.com/developers/docs/references/images-api Contentful's Images API}.
 *
 *
 * @param src
 * @param width
 * @param height
 * @param format This will not apply if the image is an SVG
 * @param quality A number been 1 and 100
 */
export function createContentfulAssetUrl({
  src,
  width,
  height,
  format,
  quality,
}: {
  src: string;
  width?: number;
  height?: number;
  format?: 'jpg' | 'png' | 'webp' | 'gif' | 'avif' | 'tiff' | (string & NonNullable<unknown>);
  quality?: number;
}): string {
  const url = new URL(src.startsWith('//') ? `https:${src}` : src);
  if (width) {
    url.searchParams.set('w', width.toString());
  }
  if (height) {
    url.searchParams.set('h', height.toString());
  }
  if (format && !url.pathname.endsWith('.svg')) {
    url.searchParams.set('fm', format);
  }
  if (quality) {
    url.searchParams.set('q', quality.toString());
  }
  return url.toString();
}
